import { getAppEnvironmentBranding } from "./app-environment";

// Path data mirrors src/components/icons/alphartis.svg; kept inline since favicons can't use CSS/currentColor.
const LOGO_PATH = "m250.4 54.5l-244.9 245.4v146.4h146.2l98.7-99 98.8 99h146.1v-146.4l-244.9-245.5z";

export function applyFaviconColor(): void {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    return;
  }

  const { color } = getAppEnvironmentBranding();
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path fill="${color}" d="${LOGO_PATH}"/></svg>`;
  link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
